import { render, staticRenderFns } from "./dropPaneButton.vue?vue&type=template&id=168f516c&scoped=true&"
import script from "./dropPaneButton.vue?vue&type=script&lang=js&"
export * from "./dropPaneButton.vue?vue&type=script&lang=js&"
import style0 from "./dropPaneButton.vue?vue&type=style&index=0&id=168f516c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f516c",
  null
  
)

export default component.exports